import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_daily_progress_entry = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const canView  = hasPermission("Vehicle Daily Progress Entry", "view");
      const canEntry = hasPermission("Vehicle Daily Progress Entry", "entry");
      const canEdit  = hasPermission("Vehicle Daily Progress Entry", "edit");
      const canDel   = hasPermission("Vehicle Daily Progress Entry", "del");
    

  // Fetch branches only once
 useEffect(() => {
  const fetchVehicleReportBranches = async () => {
    let progress = 0;

    const updateProgress = (val) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${val}%`;
      if (text) text.innerText = `Loading... ${val}%`;
    };

    Swal.fire({
      title: "Loading Branch List",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_details_report_own");
      setBranches(response.data.branches || []);
      updateProgress(100);
      setTimeout(() => Swal.close(), 400);
    } catch (error) {
      console.error("Error fetching branches:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load branches.",
      });
    }
  };

  {canView && (
  fetchVehicleReportBranches()
  )}
}, []);

  // Fetch data based on selected branch
  useEffect(() => {
    if (selectedBranch) {
        setLoading(true); 
      axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_details_report_own?branch_code=${selectedBranch}`)
        .then((response) => {
          setData(response.data.vehicles);
          setFilteredData(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        })
        .finally(() => {
            setLoading(false); 
          });
    }
  }, [selectedBranch]);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.vehicle_code && item.vehicle_code.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_name && item.vehicle_name.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_number && item.vehicle_number.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate('/vehicle_view_add_hire');
    }
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">{selectedBranch} - Vehicle Hour Meter List</h2>
          <div>
            <Time />
          </div>
        </section>

      <div className="vehicle-class">
  <div>
    <p>Branch wise Report:</p>
    <select 
      value={selectedBranch} 
      onChange={(e) => setSelectedBranch(e.target.value)} 
      required 
      className="branch-select"
    >
      <option value="">Select Branch</option>
      {branches.map((item) => (
        <option key={item.branchMaster_code} value={item.branchMaster_code}>
          {item.branchMaster_name}
        </option>
      ))}
    </select>
  </div>

  <div>
    <p>Select your vehicle:</p>
    <select className="branch-select" onChange={handleSelection}>     
      <option value="/own">Own Vehicle</option> 
      <option value="/hire">Hire Vehicle</option>  
    </select>
  </div>
</div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
            <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Condition</th>
                <th>Vehicle Number</th>
                <th>Vehicle Name</th>
                <th>Vehicle Type</th>
                <th>Vehicle Basis</th>
              </tr>

            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="7" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        {canEntry && (
        <td>
          {item.fld_vehiclecondition === "Uc-Uncondition vehicle" ? (
            <>{item.vehicle_code}</>
          ) : (
            <Link to={`/vehicle_working_hours_own/${item.vehicle_code}/${item.vehicle_number}/${item.vehicle_name}/${item.branch_code}/${item.vehicle_basis}`}>{item.vehicle_code}</Link>
          )}
        </td>
        )}
        <td>{item.fld_vehiclecondition}</td>
        <td>{item.vehicle_number}</td>
        <td>{item.vehicle_name}</td>
        <td>{item.vehicle_type}</td>
        <td>{item.vehicle_basis}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)}  disabled={currentPage === 1}>Previous</button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>{index + 1}</button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_daily_progress_entry;
